import { AnalyticsService } from '@alison/analytics/client';
import type { ReactNode } from 'react';
import { SingleSelectControl } from '../../filters/SingleSelectControl';
import { TOP_MARKET_CHOICES, toTopMarkets } from '../data/constants';
import type { TopMarkets } from '../data/types';

export interface TopMarketsSelection {
  value: TopMarkets;
  onChange: (value: TopMarkets) => void;
}

/** Lives on the market panels rather than the board filter bar: it bounds only these two, and every
 * scope-wide number on the board is still computed over every market. */
export function TopMarketsControl({ value, onChange }: TopMarketsSelection): ReactNode {
  return (
    <SingleSelectControl
      label="Markets"
      options={TOP_MARKET_CHOICES}
      value={String(value)}
      onChange={(next) => {
        AnalyticsService.track('Filter - Changed', {
          bar: 'media',
          filter: 'topMarkets',
          values: [next],
        });
        onChange(toTopMarkets(Number(next)));
      }}
    />
  );
}
